// Turning report criteria into sentences — the cover page's "Criteria" block
// and the Recent reports table both read from this.
//
// The sentences are `describeCriteria` from `@ap/shared`, the server's own: the
// server stores the normalized criteria on the audit row and the cover page
// prints them, so both must describe a report the same way (code review D-08,
// 2026-10-03 — a hand-written twin stood here until then).

import {
  describeCriteria,
  isMoneyString,
  type CriteriaLabels,
  type ReportCriteria as SharedReportCriteria,
} from '@ap/shared'
import type { ReportCriteria } from '../api/types'

export type { CriteriaLabels }

/**
 * The criteria as sentences, in a fixed order. A Total bound that is not yet a
 * decimal — a half-typed `-` in the form — is left out rather than thrown on:
 * the shared rule parses money strictly, and the form describes what a person
 * is still typing.
 */
export function describeReportCriteria(
  criteria: ReportCriteria,
  labels: CriteriaLabels = {},
): string[] {
  const money = (value: string | undefined) => (value !== undefined && isMoneyString(value) ? value : undefined)
  // The app types a few list criteria as plain strings; the sentences only print them.
  const wire = { ...criteria, total_min: money(criteria.total_min), total_max: money(criteria.total_max) }
  return describeCriteria(wire as SharedReportCriteria, labels)
}
